// extracted by mini-css-extract-plugin
export default {"container":"CommonMenu_container__A67F-","topItem":"CommonMenu_topItem__nQrRc","menu":"CommonMenu_menu__Xafev","submenu":"CommonMenu_submenu__2gEbK"};